import { cn } from '@/lib/utils';

const DETAIL_LINE_CLASS = 'block text-xs font-normal text-muted-foreground';

interface PersonDetailLinesProps {
  name: string;
  designationName?: string | null | undefined;
  mobile: string | null;
}

export function PersonDetailLines({ name, designationName, mobile }: PersonDetailLinesProps) {
  return (
    <>
      <span className="block">{name}</span>
      {designationName ? <span className={DETAIL_LINE_CLASS}>{designationName}</span> : null}
      {mobile ? <span className={cn(DETAIL_LINE_CLASS, 'tabular-nums')}>{mobile}</span> : null}
    </>
  );
}
